/**
 * `true` no Firefox e derivados (Zen, LibreWolf, Waterfox — todos trazem
 * "Firefox" no user agent). Usado só onde o Firefox se comporta diferente de
 * forma MEDIDA, como a conexão que o `<video>` prende (ver `filaDeVideos.ts`).
 */
export function ehFirefox(): boolean {
    return typeof navigator !== 'undefined' && /firefox/i.test(navigator.userAgent);
}
